module.exports = __webpack_public_path__ + "static/media/logo_white.00dde438.svg";